module.exports = __webpack_public_path__ + "static/media/chanel-gabrielle-big.18913c5a.png";